import { FETCH_SELLER } from './actions'
import { getCookies } from '../../utility/Cookies'
import { decryptCrypto } from '../../utility/Encryption'

const initialState = {
  seller: getCookies('_wssc') ? decryptCrypto(getCookies('_wssc')) : null,
  error_seller: true,
}

export default function SellerReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SELLER:
      return {
        ...state,
        seller: action.data,
      }
    default:
      return state
  }
}
